import { useEffect } from 'react';
import { useErrorTracking } from '@/hooks/useErrorTracking';

/**
 * Component to initialize error tracking system
 * This should be placed inside AuthProvider but outside of any routing
 */
export const ErrorTrackingInitializer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // Initialize error tracking with auth context
  useErrorTracking();
  
  return <>{children}</>;
};